import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Import translation files
import arAuth from '../locales/ar/auth.json';
import arBilling from '../locales/ar/billing.json';
import arCommon from '../locales/ar/common.json';
import arDashboard from '../locales/ar/dashboard.json';
import arInvoices from '../locales/ar/invoices.json';
import arLeases from '../locales/ar/leases.json';
import arMaintenance from '../locales/ar/maintenance.json';
import arProfile from '../locales/ar/profile.json';
import arSettings from '../locales/ar/settings.json';
import enAuth from '../locales/en/auth.json';
import enCommon from '../locales/en/common.json';
import enDashboard from '../locales/en/dashboard.json';
import enInvoices from '../locales/en/invoices.json';
import enLeases from '../locales/en/leases.json';
import enMaintenance from '../locales/en/maintenance.json';
import enBilling from '../locales/en/billing.json';
import enProfile from '../locales/en/profile.json';
import enProperty from '../locales/en/property.json';
import enSettings from '../locales/en/settings.json';
import arProperty from '../locales/ar/property.json';

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    maintenance: enMaintenance,
    billing: enBilling,
    leases: enLeases,
    invoices: enInvoices,
    profile: enProfile,
    settings: enSettings,
    property: enProperty,
  },
  ar: {
    common: arCommon,
    auth: arAuth,
    dashboard: arDashboard,
    maintenance: arMaintenance,
    billing: arBilling,
    leases: arLeases,
    invoices: arInvoices,
    profile: arProfile,
    settings: arSettings,
    property: arProperty,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'lang',
      caches: ['localStorage'],
    },
    
    react: {
      useSuspense: false,
    },
  });

// Set document direction from i18n (once)
i18n.on('languageChanged', (lng) => {
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lng);
});

export default i18n;
